import * as React from 'react';
import { Route, Switch, useParams } from 'react-router-dom';

import { useGetSubscriber } from '../../Hooks/Consumer/useGetSubscriber';
import { SubscriberManagement } from './SubscriberManagement/SubscriberManagement';
import { SubscriberDetailsHeaderError, SubscriberDetailsHeaderLoading } from './SubscriberManagement/SubscriberManagementHeader';
import { SubscriberPage } from './SubscriberPage/SubscriberPage';

type SubscriberRouteProps = {
  addNew: boolean;
};

type SubscriberRouteContentProps = SubscriberRouteProps & {
  subscriberId: string;
};

function SubscriberRouteContent({ addNew, subscriberId }: SubscriberRouteContentProps): React.ReactElement {
  const [subscriberRecord, isSubscriberRecordLoading, subscriberError] = useGetSubscriber(subscriberId);

  if (isSubscriberRecordLoading) {
    return <SubscriberDetailsHeaderLoading />;
  }

  if (subscriberError || !subscriberRecord) {
    return <SubscriberDetailsHeaderError message={subscriberError ?? 'Failed to fetch consumer details'} />;
  }

  return <SubscriberManagement addNew={addNew} subscriberRecord={subscriberRecord} />;
}

function SubscriberRoute({ addNew }: SubscriberRouteProps): React.ReactElement {
  const { paramConsumerId }: { paramConsumerId: string } = useParams();

  return <SubscriberRouteContent key={paramConsumerId} addNew={addNew} subscriberId={paramConsumerId} />;
}

export function ConsumerRoutes(): React.ReactElement {
  return (
    <div data-testid="consumer-routes">
      <Switch>
        <Route path="/consumers/" exact>
          <SubscriberPage addNew={false} />
        </Route>
        <Route path="/consumers/addNew" exact>
          <SubscriberPage addNew={true} />
        </Route>
        <Route path="/consumers/:paramConsumerId/addNew">
          <SubscriberRoute addNew={true} />
        </Route>
        <Route path="/consumers/:paramConsumerId/:paramRequestId">
          <SubscriberRoute addNew={false} />
        </Route>
        <Route path="/consumers/:paramConsumerId/">
          <SubscriberRoute addNew={false} />
        </Route>
      </Switch>
    </div>
  );
}
